<template>
    <div class="main-con el-main">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "EquitySwapTx"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/EquitySwapTx.vue